import { CreateSingleton } from "@pdfking/tfunc"
import { BlobUrl } from "@pdfking/workflow/actions/pdfengine/BlobUrl"
import track_promise from "@pdfking/workflow/utils/track_promise"
import { reactive } from "vue"

import get_filedata from "../naming/get_filedata"
import type { FileObject } from "../types/FileObject"
import type { FileProvider } from "../types/FileProvider"

export default ({
  path,
  factory,
  file_meta,
}: {
  path: string
  factory: FileProvider
  file_meta?: Record<string, string>
}): FileObject => {
  const start = () => (object.loading = true)
  const finish = () => (object.loading = false)

  const get_file = CreateSingleton(() => track_promise(factory, start, finish))
  const get_url = CreateSingleton(() =>
    track_promise(
      () =>
        get_file()
          .then(BlobUrl)
          .then(url => (object.url = url)),
      start,
      finish
    )
  )

  const filedata = get_filedata(path)

  const object: FileObject = reactive({
    path,

    get_url,
    get_file,

    short_name: `${filedata.basename}.${filedata.ext}`,

    url: undefined,
    loading: false,
    file_meta: file_meta ?? {},

    get name() {
      // to be removed
      throw new Error("name is not available")
    },

    ...filedata,
  })

  return object
}
